import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography, Grid, styled } from '@mui/material';

import Services from '../../../shared/services';
import { columns } from './employee-status-columns';
import InformationForm from '../../../shared/components/ui/information-form';
import DynamicDataGrid from '../../../shared/components/ui/datagrid/datagrid';
import { IEmployeeDataResponse } from '../../../shared/interfaces/employee.interface';

const styles = {
  container: {
    width: '80%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: 'auto',
    padding: '2rem',
  },
};

const Header = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '1.75rem',
  marginBottom: '2rem',
}));

const Data = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: '1rem',
}));

const EmployeeStatus = () => {
  const navigate = useNavigate();
  const { slug } = useParams();

  const [employeeData, setEmployeeData] = useState<IEmployeeDataResponse>();

  const getEmployeeStatus = async () => {
    if (slug) {
      await Services.api.employee
        .fetch(slug)
        .then((res) => {
          const { success, errors } = res;

          if (success) {
            setEmployeeData(res);
          } else {
            const [{ message }] = errors;

            Services.toast('error', `${message}`);
            Services.log(`${message}.`);
          }
        })
        .catch(({ response: { status, statusText } }) => {
          if (status === 400) {
            Services.toast('error', `${statusText}`);
            Services.log(statusText);
          } else {
            navigate('/not-found');
            Services.log(statusText);
          }
        });
    }
  };

  useEffect(() => {
    getEmployeeStatus();
  }, []);

  return (
    <Box sx={styles.container}>
      {employeeData ? (
        <>
          <InformationForm
            title='Online HR Clearance Status Form'
            info={employeeData.data.application}
          />

          {employeeData?.data.application.signatory_remarks && (
            <Box sx={{ width: '100%', marginY: '2rem' }}>
              <Header>Clearance Form</Header>

              <Box sx={{ height: '25rem' }}>
                <DynamicDataGrid
                  columns={columns}
                  rows={employeeData.data.application.signatory_remarks}
                />
              </Box>
            </Box>
          )}
        </>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100vh' }}>
          <Typography color='gray' variant='h3'>
            No Available Data
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default EmployeeStatus;
